import { useRefresh } from 'react-admin';
import CheckIcon from '@mui/icons-material/Check';
import { Button, CircularProgress } from '@mui/material';
import { useCallback, useState } from 'react';
import { useLogEffect } from '@/util/useLogEffect';
import { adminRpcClient } from '@/providers/backendClient';

type ForceTranscriptionProps = {
  recordingId: string;
};

export const ForceTranscriptionButton = ({
  recordingId,
}: ForceTranscriptionProps) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const refresh = useRefresh();

  const onForceTranscription = useCallback(async () => {
    setIsUpdating(true);

    const { error } = (await adminRpcClient(
      'PUBLIC_ADMIN_therapistRecordings_transcribeOne',
      [recordingId],
    ).catch(err => {
      alert('Error transcribing Note input: ' + err.message);

      return { error: err.message };
    })) as any;

    setIsUpdating(false);

    refresh();

    if (error) {
      alert('Error transcribing Note input: ' + error.message);
    }
  }, [recordingId, refresh]);

  useLogEffect('RECORDING ID', recordingId);

  return (
    <Button
      disabled={isUpdating}
      onClick={onForceTranscription}
      startIcon={
        !isUpdating ? <CheckIcon /> : <CircularProgress size="1rem" />
      }
    >
      {!isUpdating ? 'Retry Transcription' : 'Transcribing'}
    </Button>
  );
};
